

































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import StarRating from "vue-star-rating";
import "../styles/Videos.scss";
import moment from "moment";
import * as franc from "franc";
import VideoQuiz from "./VideoQuiz.vue";
import Loader from "../views/Loader.vue";
import { VideoModel } from "../models/training-types";

declare var amp: any;
declare var AppInsightsUtils: any;
declare const InstallTrigger: any;
declare const window: any;

@Component({
  components: {
    "star-rating": StarRating,
    "video-quiz": VideoQuiz,
    "loader": Loader,

  },
  props: ["topicid", "referencevalue", "contentIds", "contentType", "topicname","isVimeoVideo","videoUrl2"],
})
export default class TraningVideos  extends Vue {
  private service = new GeneralService();
  private level_id;
  private level_id2: string = "";
  private auth = new AuthService();
  starSize: number = 20;
  private topiclimit: number;
  private ifQuestionExists = false;
  private teacherID = "";
  private subjectID = "";
  private teacherName = "";
  private totalTime = 0;
  private prevStartTime = 0;
  private lastUpdatedTime = 0;
  private ended = false;
  private enableQuiz = false;
  private startSeek = 0;
  private stopSeek = 0;
  private totalSeek = 0;
  private maxWatched = 0;
  private ratingPrevId = "";
  private isSmart = false;
  private isVideoQuiz = false;
  private sentQuestion = false;
  private totalTimeWatched = 0;
  private checkingTopicId = '';
  public contentIds: any;
  public IsArvo: boolean;
  public contentType: any;
  private referenceValue: any='';
 topicname: string;
  private startError = false;
  private errorMessageVideo = "";
  private lastTime = 0;
  public showNoRecordMessage: boolean = false;
  private iframeHtml = '';
  hideModal: boolean = false;
  private boardId: any = '';
  private classId: any = '';
  videoUrl: any;
private isVimeoVideo: boolean;
  private showTime() {
    this.prevStartTime = this.player.currentAbsoluteTime();
  }

  private pauseTime() {
    this.totalTime +=
      this.player.currentAbsoluteTime() - this.prevStartTime;
  }

  private progressClicked() {
    this.lastUpdatedTime = this.player.player_.mediaPlayer.currentAbsoluteTime;
  }

  private videoCompleted() {
    this.ended = true;
    
    // Mark video as completed
    // this.markVideoCompleted();
  }

  // Mark video as completed in parent component
  // private markVideoCompleted(): void {
  //   // Emit event to parent component to mark as completed
  //   this.$emit('video-completed', {
  //     topicid: this.topicid,
  //     contentIds: this.contentIds,
  //     contentType: this.contentType
  //   });
  // }

  private checkLang(str) {
    var lst = ["und", "urd", "fas", "pes", "skr", "arb", "uig"];
    var lan = franc(str, { minLength: 3 });

    return lst.indexOf(lan) > -1;
  }

  private seekingTime(seeked) {
    this.maxWatched = Math.max(
      this.maxWatched,
      this.player.currentAbsoluteTime()
    );
  }
  closePopup() {
    this.showPopup = false;

  }
  transformHtmlToHeading(html) {
    // Replace <p> tags with <h4> tags
    const parser = new DOMParser();

    // Parse the HTML string
    const doc = parser.parseFromString(html, 'text/html');

    // Extract and return the plain text content
    return doc.body.textContent || '';
  }
  private seekedTime() {
    this.totaltime += this.lastUpdatedTime - this.prevStartTime;
    this.stopSeek = this.player.currentTime();

    if (Math.abs(this.stopSeek - this.startSeek) > 2) {
      this.totalSeek += this.stopSeek - this.startSeek;
    }

    this.startSeek = this.stopSeek;
  }

  private items = [
    {
      text: "Subjects",
      to: { name: "videosubject" },
    },
    {
      text: this.$store.state.selectSubjectName,
      href: "#",
    },
    {
      text: this.$store.state.selectSubjectName,
      href: "#",
    },
    {
      text: "Library",
      active: true,
    },
  ];

  private sourceLoaded = false;
  private entities: any[] = [];

  // private entities: VideoModel[] = [];
  private entity: VideoModel = {
    id: "",
    url: "",
    thumbnailUrl: "",
    isDefault: "",
    platformType: "",
    description: "",
  };

  private question = "";
  private currentTopicId = "";
  private totaltime: number = 0;
  private previous: number = 0;
  private previousW: number = 0;
  private duration: number = 0;
  private actualW: number = 0;
  private srcToken: any;
  public loading: boolean = false;
  public showPopup: boolean = false;
  public showPopupRating: boolean = false;
  private isCollapsed = false;
  private firstTimeVideo = true;
 public videoUrl2:string;
  private ratingPrev = 0;

  private classSection = "";
  private sending = false;
  public FeedBackRatingList: any = [];
  private parts: Array<Parts> = [];
  public ratingValues: any = [0, 0, 0, 0];
  private chankParts: Array<Chank> = [];
  private totalChanks: number = 20;
  private chankStarted: boolean = false;

  private VsId: string = "";

  private rating: number = 0;
  private source: string = "";

  topicid: string;
  private player: any;

  private followUp = "";

  private timeInterval;
  private firstTime: boolean = true;

  private teacherData: any = [];
  
  // local copy of the incoming `topicid` prop to avoid mutating the prop directly
  private selectedTopicId: string = "";

  created() {
    this.loading = false;
    this.level_id = localStorage[config.classLevl];
    this.level_id2 = this.$store.state.selectSubject;

    this.VsId = localStorage["VsId"];

    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }

    // keep a local copy of the incoming prop
    this.selectedTopicId = this.topicid || "";
    if(this.isVimeoVideo){
      this.videoUrl=this.videoUrl2;
    }
    else{
    const val = this.selectedTopicId + "?" + this.level_id2 + "?" + this.contentType + "?" + this.contentIds;
    this.service
      .getTrainingVideosContent(val)

      .then((result) => {
        
        // response shape can be either an array or an object with `data` / `con` properties
        let items: any[] = [];
        if (Array.isArray(result)) items = result;
       

        // Extract only Vimeo platform entries and map to VideoModel-like objects
        const vimeoList: any[] = [];
        items.forEach((it: any) => {
          const platforms = it.platforms || it.Platforms || [];
          const vimeo = platforms.find((p: any) => p.platformType && p.platformType.toLowerCase() === 'vimeo');
          if (vimeo && vimeo.url) {
            vimeoList.push({
              id:  vimeo.id,
              url: vimeo.url,
              thumbnailUrl: vimeo.thumbnailUrl,
              isDefault: vimeo.isDefault || false,
              platformType: vimeo.platformType || 'Vimeo',
              description: it.statement,
              // keep original item in case other fields are needed
              _raw: it,
            });
          }
        });

        this.entities = vimeoList;
        this.loading = false;

        if (this.entities && this.entities.length > 0) {
          // If a topicid was provided, try to play that id, otherwise play the first Vimeo video
          const playId =this.entities[0].id;
          
          this.current(playId);
          this.actualW = 0;
          this.duration = 0;
        }
      })
      .catch((err) => {
        this.loading = false;
        console.error(`Error: ${err.message}`);
      });
    }
    
  }


  mounted() {

    this.loading = true;
    AppInsightsUtils.setAuthNUserContext(
      this.auth.isAuthenticated(),
      this.auth.session.userName.split("@")[0]
    );
    setInterval(() => {
      if (this.player !== undefined && this.player.error !== undefined && this.player.error() === null && this.startError && this.player.length > 0) {
        this.startError = false;
        this.player.currentTime(this.lastTime);
        this.errorMessageVideo = "";
      }
    }, 1000);

    const jwtResponse = localStorage.getItem('jwtToken');
    this.service
      // .getStudentInfoEMS_Encrypt(this.auth.session.userName.split("@")[0])
      // .then((result) => {
      //   this.loading = false;
      //   this.classSection = result.data[0].Class_section_id;
      // });
  }

  private setRating(rating) {

    this.showPopup = false;
    this.showPopupRating = false;
    if (rating > 3) {
      this.showPopup = false;
      this.service.ratingSave(this.currentTopicId + "?" + rating);
      this.showPopupRating = true;
      setTimeout(() => {
        this.showPopupRating = false;
      }, 2000);
    }
    else {
      this.FeedBackRatingList = [];
      this.ratingValues = [];
      // this.hideModal = true;
      this.showPopup = true;
      this.showPopupRating = false
      this.service.ratingSave(this.currentTopicId + "?" + rating);
      this.service.GetNewRatingFeedback().then((result) => {
        this.FeedBackRatingList = result.data;
        
      });;

    }

  }

  private submitFeedback() {


    this.showPopup = false;


    const feedbackData = this.FeedBackRatingList.map((ratingItem, index) => {
      return {
        id: ratingItem.negativeVideoRattingId,
        rating: this.ratingValues[index] || 0,
      };
    });
    if (this.FeedBackRatingList.remarks === undefined) {
      this.FeedBackRatingList.remarks = "";
    }
    const feedbackString = feedbackData.map(item => `${item.id}=${item.rating}`).join('&');
  

    this.service.ratingSaveList(this.currentTopicId + "?" + feedbackString, this.FeedBackRatingList.remarks);
    this.FeedBackRatingList = [];
    this.showPopupRating = true;
    setTimeout(() => {
      this.showPopupRating = false;
    }, 2000);
  }

  private setRatingPrev(rating) {
    this.showPopup = false;
    if (this.ratingPrev > 3) {
      this.showPopup = false;
      this.service.ratingSave(this.currentTopicId + "?" + this.ratingPrev);
      this.$bvModal.hide("rating");

    }
    else {
      this.FeedBackRatingList = [];
      this.ratingValues = [];
      this.$bvModal.hide("rating")
      this.showPopup = true;
      this.service.ratingSave(this.currentTopicId + "?" + this.ratingPrev);
      this.service.GetNewRatingFeedback().then((result) => {
        this.FeedBackRatingList = result.data;
      
      });;

    }
  }

  private sendData() {
    let watchedTime = this.player.currentAbsoluteTime();
    let totalTime = this.player.duration();

    const jsonSend = {
      videoId: this.currentTopicId,
      videoName: this.$store.state.topicSelectName,
      username: this.auth.session.userName,
      finishedVideo: this.ended,
      systemEnvironment: navigator.userAgent,
      ip: localStorage[config.currentIpAddress],
      maxLengthWatched: Math.max(this.maxWatched, watchedTime),
      maxDuration: totalTime,
      sessionId: localStorage[config.sessionId],
      sessionTime: localStorage[config.sessionIdTime],
      dataTimeStamp: moment().unix(),
    };

    this.service.sendData(jsonSend).then((response) => console.log(response));
  }

//   private goingAway(action: string) {
// this.$router.push("traningmodules");
//   }

  // private checkBrowser(src, calback) {
  //   let brow = "widevine";
  //   if (this.$browserDetect.isEdge || this.$browserDetect.isIE) {
  //     brow = "playReady";
  //   }
  //   if (this.$browserDetect.isSafari) {
  //     brow = "clear";
  //   }
  //   this.getToken(src, brow, (data) => {
  //     calback(data);
  //   });
  //   this.showPopupRating = false;
  // }

private checkBrowser(
  src: string,
  callback: (data: any) => void
): void {
  let brow = 'widevine';

  if (this.$browserDetect.isEdge || this.$browserDetect.isIE) {
    brow = 'playReady';
  } else if (this.$browserDetect.isSafari) {
    brow = 'clear';
  }

  this.getToken(src, brow, (data: any) => {
    callback(data);
  });

  this.showPopupRating = false;
}

  private getToken(source, brow, callback) {
    this.service
      .getVideoToken(source, brow)
      .then((result) => {
        this.srcToken = result;
        callback(result);

        // only set player src if the player is already initialized
        if (this.player && typeof this.player.src === 'function') {
          try {
            this.player.src([
              {
                src: result.src, //response.src,
                type: "application/vnd.ms-sstr+xml", //response.type,
                protectionInfo: [
                  {
                    type: result.protectionInfo.type,
                    certificateUrl: result.protectionInfo.certificateUrl,
                    authenticationToken: result.protectionInfo.authenticationToken,
                  },
                ],
              },
            ]);
          } catch (e) {
            console.warn('Failed to set player.src in getToken', e);
          }
        }
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  private sidebarQuiz(check, id) {
    if (check) {
      this.current(id);
      //this.getVideoQuestions(id);
    } else {
      if (this.player)
        this.player.pause();
      this.$bvModal.show('quiz-locked')
    }
  }

  // private current(id) {
  //  debugger
  //   this.loading = false;
  //   this.showPopup = false;

  //   console.log('gergdfbdfr', id)
  //   // if (this.topicid === id && !this.firstTimeVideo) {
  //   //   return
  //   // }

  //   this.sourceLoaded = false;


  //   if (this.player) {
  //     this.player.pause();
  //   }

  //   // update local selection only; do not mutate the prop `topicid`
  //   this.selectedTopicId = id;
  //   this.totalSeek = 0;

  //   // if (this.firstTimeVideo) {
  //   //   this.firstTimeVideo = false;
  //   // } else if (this.rating == 0) {
  //   //   this.$bvModal.show("rating");
  //   // }
  //   this.ratingPrev = 0;
  //   this.ratingPrevId = this.currentTopicId;

  //   // this.maxWatched = this.entity.maxWatched;
  //   this.currentTopicId = id;
  //   console.log('topicid check', this.entities.find((e) => e.id))
  //   const entity = this.entities.find((e) => e.id === id);

  //   if (entity !== undefined) {
  //     this.source = entity.url;

  //     if (this.source === null || this.source === "") {

  //       this.showNoRecordMessage = true;
  //       console.log('fdsfhodsf', this.showNoRecordMessage)
  //     }
  //     else {
  //       this.showNoRecordMessage = false;
  //       this.$store.state.topicSelectName = this.transformHtmlToHeading(this.$store.state.selectSubjectName);
  //       this.entity = entity;
  //       this.entity.description = this.transformHtmlToHeading(this.$store.state.selectSubjectName);
  //       this.duration = 26;
  //       //.saveWatched();

  //         this.checkBrowser(entity.url, (data) => {


  //           this.loadVideo();


  //         });



  //         // this.videoData();

  //         this.chankStarted = false;
  //         this.actualW = 0;
  //         this.duration = 0;
        

  //       // this.service.getPGCtrating(id).then((response) => {
  //       //   this.rating = 0;
  //       //   if (response.data[0]) {
  //       //     this.rating = response.data[0].rating;
  //       //   }
  //       // });
  //     }
  //   }

  // }
private current(id): void {
  this.loading = false;
  this.showPopup = false;

  // Update selection
  this.selectedTopicId = id;
  this.currentTopicId = id;
  this.totalSeek = 0;

  this.ratingPrev = 0;
  this.ratingPrevId = id;

  const entity = this.entities.find((e) => e.id === id);

  if (!entity || !entity.url) {
    this.showNoRecordMessage = true;
    return;
  }

  this.showNoRecordMessage = false;

  // Set topic info
  this.entity = entity;
  this.entity.description = this.transformHtmlToHeading(
    this.$store.state.selectSubjectName
  );
 
  // 🔥 THIS IS THE ONLY THING NEEDED FOR VIMEO
  this.videoUrl = entity.url; // Vimeo embed URL

  // Optional: reset flags
  this.chankStarted = false;
  this.actualW = 0;
  this.duration = 0;
}

  private ampEventHandler(evt) {
    AppInsightsUtils.ampEventHandler4AppInsights(
      evt,
      this.player,
      this.$store.state.topicSelectName
    );
  }

  private registerEvents(amPlayer, ampEventHandler) {
    var events = [
      amp.eventName.loadstart,

      amp.eventName.durationchange,

      amp.eventName.loadeddata,

      amp.eventName.loadedmetadata,

      amp.eventName.canplaythrough,

      amp.eventName.waiting,

      amp.eventName.play,

      amp.eventName.playing,

      amp.eventName.ended,

      amp.eventName.seeking,

      amp.eventName.seeked,

      amp.eventName.pause,

      amp.eventName.fullscreenchange,

      amp.eventName.volumechange,

      amp.eventName.error,

      amp.eventName.timeupdate,

      amp.eventName.playbackbitratechanged,

      amp.eventName.downloadbitratechanged,
    ];
    for (let i = 0; i < events.length; i++) {
      this.player.addEventListener(events[i], ampEventHandler);
    }
  }

  private loadVideo() {
    let client = document.getElementById("main-content");
    if (client !== null) {
      if (typeof amp === 'undefined') {
        console.warn('AMP (azure media player) is not available in this environment.');
        this.errorMessageVideo = 'Video player unavailable. Please try again later.';
        return;
      }

      this.player = amp("azuremediaplayer", {
        nativeControlsForTouch: false,
        logo: { enabled: false },
        autoplay: false,
        fluid: true,
        playbackSpeed: {
          enabled: true,
          initialSpeed: 1.0,
          speedLevels: [
            { name: "x4.0", value: 4.0 },
            { name: "x3.0", value: 3.0 },
            { name: "x2.0", value: 2.0 },
            { name: "x1.75", value: 1.75 },
            { name: "x1.5", value: 1.5 },
            { name: "x1.25", value: 1.25 },
            { name: "normal", value: 1.0 },
            { name: "x0.75", value: 0.75 },
            { name: "x0.5", value: 0.5 },
          ],
        },
        controls: true,
        width: "auto",
        height: 600,
        techOrder: [
          "azureHtml5JS",
          "flashSS",
          "html5FairPlayHLS",
          "silverlightSS",
          "html5",
        ],
      });
      try {
        this.player.addEventListener(amp.eventName.play, this.showTime);
        this.player.addEventListener(amp.eventName.pause, this.pauseTime);
        this.player.addEventListener(amp.eventName.seeked, this.seekingTime);
        this.player.addEventListener(amp.eventName.timeupdate, this.seekedTime);

        this.player.addEventListener(amp.eventName.ended, this.videoCompleted);

        this.registerEvents(this.player, this.ampEventHandler);
      } catch (e) {
        console.warn('Error registering AMP events', e);
      }
    }
    // ensure srcToken is available before attempting to use it
    if (!this.srcToken || !this.srcToken.src) {
      console.warn('No srcToken available when attempting to load video');
      this.errorMessageVideo = 'Video source unavailable. Please try again later.';
      return;
    }

    if (this.player && typeof this.player.src === 'function') {
      try {
        this.player.src([
          {
            src: this.srcToken.src, //response.src,
            type: this.srcToken.Type, //response.type,
            protectionInfo: [
              {
                type: this.srcToken.protectionInfo.type,
                certificateUrl: this.srcToken.protectionInfo.certificateUrl,
                authenticationToken:
                  this.srcToken.protectionInfo.authenticationToken,
              },
            ],
          },
        ]);

        this.player.addEventListener("error", this.errorPlayback);
      } catch (e) {
        console.warn('Error setting player src or attaching error handler', e);
      }
    } else {
      console.warn('Player is not initialized when trying to set src');
      this.errorMessageVideo = 'Video player unavailable. Please try again later.';
      return;
    }
    this.totaltime = 0;
    clearInterval(this.timeInterval);
    this.timeInterval = setInterval(() => {
      if (this.totaltime == 0) {
        this.totaltime = Math.round(this.player.duration());

        if (this.totaltime > 0) {
          this.resetTimer(this.totaltime);
        }
      }

      if (this.totaltime > 0) {
        this.chunkTimer(this.player.currentTime());
      }

      // this.checkState();
    }, 1000);

    this.sourceLoaded = true;
  }

get autoPlayUrl(): string {
  if (!this.videoUrl) return '';

  // If URL already has params, append with &
  const separator = this.videoUrl.includes('?') ? '&' : '?';

  return (
    this.videoUrl +
    separator +
    'autoplay=1&muted=1&playsinline=1'
  );
}


  playVideo() {
    if (this.player)
      this.player.play();

    this.$bvModal.hide('quiz-locked');
    this.$bvModal.hide('quiz-unlocked');
  }

  errorPlayback() {
    this.errorMessageVideo =
      "There was an issue in your playback, kindly check your internet connection. We will reload the video so you can seamlessly view it again.";

    try {
      this.lastTime = this.player && typeof this.player.currentTime === 'function' ? this.player.currentTime() : this.lastTime;
      this.startError = true;

      if (this.player && typeof this.player.src === 'function') {
        // prefer srcToken if available, otherwise fallback to the original source
        const srcToUse = this.srcToken && this.srcToken.src ? this.srcToken.src : this.source;
        if (srcToUse) {
          this.player.src([{ type: "application/vnd.ms-sstr+xml", src: srcToUse }]);
        } else {
          console.warn('No fallback source available for errorPlayback');
          this.errorMessageVideo = 'Unable to reload video source.';
        }
      }
    } catch (e) {
      console.warn('Error during errorPlayback handling', e);
    }
  }

  private createChunks() {
    if (this.chankStarted == false && this.totaltime > 0) {
      this.chankParts = [];
      this.chankStarted = true;
      var oneChank = this.totaltime / this.totalChanks;

      for (var i = 0; i < this.totalChanks; i++) {
        this.chankParts.push({
          start: Math.round(oneChank * (i + 1) - oneChank),
          end: Math.round(oneChank * (i + 1)),
          watched: 0,
        });
      }

      this.chankStarted = true;
    }
  }

  private resetTimer(videoTime) {
    this.totaltime = Math.round(videoTime);

    if (this.chankStarted == false && this.totaltime > 0) {
      this.chankParts = [];
      this.chankStarted = true;
      var oneChank = this.totaltime / this.totalChanks;

      for (var i = 0; i < this.totalChanks; i++) {
        this.chankParts.push({
          start: Math.round(oneChank * (i + 1) - oneChank),
          end: Math.round(oneChank * (i + 1)),
          watched: 0,
        });
      }

      this.chankStarted = true;
    }
  }

  private paidMessage() {
    // this.dialog.show<PayComponent>(PLATFORM.moduleName('app/backend/pay.component'));
  }

  private sumActual() {
    var realW = 0;
    for (var i = 0; i < this.parts.length; i++) {
      if (this.parts[i].vieved === true && this.parts[i].percentage > 0) {
        realW += this.parts[i].percentage;
      }
    }

    return realW;
  }

  private chunkTimer(timeToken) {
    this.duration = Math.round((Math.round(timeToken) * 100) / this.totaltime);
    this.actualW = timeToken;

    if (this.chankParts.length > 0) {
      var watche = 0;
      for (var i = 0; i < this.totalChanks; i++) {
        var start = this.chankParts[i].start;
        var end = this.chankParts[i].end;

        if (this.actualW >= start && this.actualW <= end) {
          var watchedChunk = timeToken - this.chankParts[i].start;
          this.chankParts[i].watched =
            Math.round((watchedChunk * 100) / this.chankParts[i].end) > 50
              ? 100
              : Math.round((watchedChunk * 100) / this.chankParts[i].end);
        }
        watche += this.chankParts[i].watched;
      }
      this.duration = Math.round(
        (watche / (this.chankParts.length * 100)) * 100
      );
    } else {
      this.createChunks();
    }
  }

  private saveWatched() {
    var topicsWatched: TopicsWatched = {
      topicWatchId: config.createGuid(),
      userId: this.auth.session.userId,
      topicId: this.entity.id,
      enableMcq: this.enableQuiz ?? false,
      operationOn: new Date(Date.now()),
      duration: this.actualW,
      percentage: this.duration >= 25 ? 100 : this.duration,
    };

  }

  private askQuestion() {
    let data = {
      device_Id:
        this.auth.session.userName.split("@")[0] +
        window.navigator.userAgent.replace(/\D+/g, ""),
      application_Version: "1.4.8",
      Student_ID: this.auth.session.userName.split("@")[0],
      Teacher_ID: this.teacherID,
      Question: this.question,
      userMacAddress: "dsdd",
      Subject_ID: this.subjectID,
      Section_ID: this.classSection,
      From: this.teacherName,
      Topic: this.$store.state.chapterSelectName,
      application_Name: "PGC",
    };

    if (this.sending == false) {
      this.sending = true;
      this.service.sendQuestion(data, false).then((response) => {
        this.sending = false;
        if (response.message.messageTypeId == "Success") {
          this.sentQuestion = true;
        } else {
          alert(
            "Your question could not be asked at this time. Please try again later"
          );
          throw response.message.messageTypeId;
        }
      });
    }
  }

  beforeDestroy() {
    // send telemetry and cleanup players safely
    try {
      // if azure player exists and has dispose
      if (this.player && typeof this.player.dispose === 'function') {
        this.player.dispose();
      }
    } catch (e) {
      console.warn('Error disposing player', e);
    }

    try {
      if (this.timeInterval) clearInterval(this.timeInterval);
    } catch (e) {
      console.warn('Error clearing interval', e);
    }
  }
}

interface Parts {
  percentage: number;
  vieved: boolean;
  css: string;
}

interface Chank {
  start: number;
  end: number;
  watched: number;
}
